import {
  faEraser,
  faPlusSquare,
  faSearch,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./items.css";
import {
  useTest,
  useDispatchTestForm,
  useActionsTest,
} from "../../../../../context/inventory/TestFormProvider";
import { types } from "../../../../../reducers/inventory/testReducer";
import { TYPES_ITEMS, TYPE_TESTS } from "../../../../../api/constant";
import { formatNumberCOP } from "../../../../../utilities/app.utilities";

const Items = () => {
  const state = useTest();
  const dispatch = useDispatchTestForm();
  const actions = useActionsTest();
  const { lookForCode, lookedItems } = state;
  const { item_id, item_code, item_name, item_quantity } = state.test;
  const { items } = state.test.items_test;
  const getTypeName = (type_code) => {
    const types = TYPES_ITEMS.filter((t) => t.type === type_code);
    return types.length > 0 ? types[0].name : null;
  };
  return (
    <section className="container-fluid">
      <div className="row">
        <div className="form-group col-lg-7">
          <label>Búsqueda por referencia o nombre</label>
          <div className="input-to-search">
            <input
              name="lookForCode"
              value={item_id ? item_name + " - " + item_code : lookForCode}
              disabled={item_id}
              onChange={(e) =>
                dispatch({
                  type: types.CHANGE_INPUT_TEST_FORM,
                  payload: { name: e.target.name, value: e.target.value },
                })
              }
              type="text"
              className="form-control"
            />
            <FontAwesomeIcon
              onClick={() => item_id && dispatch({ type: types.REMOVE_ITEM })}
              className="cursor-pointer "
              icon={item_id ? faEraser : faSearch}
            />
          </div>

          {lookedItems.length > 0 && !item_id && (
            <div className="container-items-looked-for flex-column">
              {lookedItems.map((item) => {
                return (
                  <label
                    key={item.id}
                    onClick={(e) =>
                      dispatch({
                        type: types.CHANGE_PAYLOAD_TEST,
                        payload: {
                          ...state.test,
                          item_id: item.id,
                          item_code: item.code,
                          item_name: item.name,
                          item_presentation: item.type,
                        },
                      })
                    }
                  >
                    {item.code} - {item.name} - {item.abreviature}
                  </label>
                );
              })}
            </div>
          )}
        </div>
        {item_id && (
          <>
            <div className="form-group col-md-2">
              <label>Cantidad</label>
              <input
                className="form-control"
                onChange={(e) =>
                  dispatch({
                    type: types.CHANGE_INPUT_TEST,
                    payload: { name: e.target.name, value: e.target.value },
                  })
                }
                name="item_quantity"
                value={item_quantity}
                type="number"
              />
            </div>
            <div className="form-group col-md-1">
              <label>&nbsp;</label>
              <div>
                <FontAwesomeIcon
                  onClick={() => actions.addItemTest()}
                  className="blue margin-auto cursor-pointer icon-plus"
                  icon={faPlusSquare}
                />
              </div>
            </div>
          </>
        )}
      </div>
      <table className="table table-default-app table-items-test">
        <thead className="thead-dark">
          <tr>
            <th scope="col">Referencia</th>
            <th scope="col">Nombre producto</th>
            <th scope="col">Tipo de medida</th>
            <th scope="col">Und. medida</th>
            <th scope="col">Cantidad</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item_test) => {
            return (
              <tr key={item_test.id}>
                <td> {item_test.code} </td>
                <td> {item_test.name}</td>
                <td> {getTypeName(item_test.type)}</td>
                <td>
                  {" "}
                  {item_test.measure_name} - {item_test.abreviature}
                </td>
                <td className="txt-right">
                  {" "}
                  {formatNumberCOP(item_test.quantity)}
                </td>
                <th className="blue cursor-pointer"><FontAwesomeIcon onClick={()=>actions.deleteItemVersion(item_test.quality_detail_id)} icon={faTrash}/></th>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
};

export default Items;
